import { createContext, useContext, useState, useCallback } from "react";

const Ctx = createContext(null);

export const STATUS = {
  planned: ["Planifié", "Planned"], assigned: ["Assigné", "Assigned"], scheduled: ["Programmé", "Scheduled"],
  in_progress: ["En cours", "In progress"], submitted: ["Soumis", "Submitted"], in_review: ["En revue", "In review"],
  approved: ["Approuvé", "Approved"], reopened: ["Rouvert", "Reopened"], absent: ["Absent", "Absent"],
  refused: ["Refusé", "Refused"], postponed: ["Reporté", "Postponed"],
};
export const PHASES = {
  scoping: ["Cadrage", "Scoping"], collection: ["Collecte", "Collection"], interviews: ["Entretiens", "Interviews"],
  corroboration: ["Corroboration", "Corroboration"], contradictory_review: ["Revue contradictoire", "Contradictory review"],
  validation: ["Validation", "Validation"], restitution: ["Restitution", "Reporting"], follow_up: ["Suivi", "Follow-up"],
  archived: ["Archivage", "Archived"],
};
export const DOMAINS = {
  career: ["Carrière", "Career"], change: ["Conduite du changement", "Change"], compensation: ["Rémunération", "Compensation"],
  engagement: ["Engagement", "Engagement"], governance: ["Gouvernance RH", "HR governance"], health_safety: ["Santé & sécurité", "Health & safety"],
  job_description: ["Description de poste", "Job description"], knowledge: ["Connaissances", "Knowledge"], learning: ["Formation", "Learning"],
  onboarding: ["Intégration", "Onboarding"], performance: ["Performance", "Performance"], recruitment: ["Recrutement", "Recruitment"],
  succession: ["Succession", "Succession"], workload: ["Charge de travail", "Workload"], general: ["Général", "General"],
};

export const FAMILIES = {
  leadership: ["Leadership", "Leadership"], short: ["Short service", "Short service"],
  intermediate: ["Mid service", "Mid service"], long: ["Long service", "Long service"],
};
export const ROLES = {
  admin: ["Administrateur", "Administrator"], lead: ["Chef de mission", "Mission lead"],
  consultant: ["Consultant", "Consultant"], reviewer: ["Réviseur qualité", "Quality reviewer"],
};
export const BANDS = { short: ["Courte", "Short"], intermediate: ["Intermédiaire", "Intermediate"], long: ["Longue", "Long"] };

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(localStorage.getItem("lang") || "fr");
  const setLang = (l) => {
    localStorage.setItem("lang", l);
    document.documentElement.lang = l;
    setLangState(l);
  };
  const tx = useCallback((fr, en) => (lang === "fr" ? fr : en), [lang]);
  const lbl = useCallback((map, k) => (map[k] ? map[k][lang === "fr" ? 0 : 1] : k || "—"), [lang]);
  return <Ctx.Provider value={{ lang, setLang, tx, lbl }}>{children}</Ctx.Provider>;
}

export const useI18n = () => useContext(Ctx);
